<template>
  <div>
    <div
      class="corporate-social-responsibility"
      v-for="(item, index) in cards.length"
      :key="index"
    >
      <div class="corporate-social-responsibility_cards">
        <div class="corporate-social-responsibility_cards-title">
          <p>
            WR1 an inclusive economic development, combining distinctive
            elements of its know-how with principles inspired by the enhancement
            of people, the respect of ethical values, the promotion of local
            culture and the protection of the environment.
          </p>
          <p>
            Sustainability is a founding element deeply rooted in the Company’s
            identity and strategy, which represents a formal commitment towards
            the communities in which it operates.
          </p>
        </div>
        <div class="corporate-social-responsibility_cards-blog-card">
          <div class="corporate-social-responsibility_cards-blog-card-text">
            <div>
              <p
                class="
                  corporate-social-responsibility_cards-blog-card-text-description
                "
              >
                WR1 an inclusive economic development, combining distinctive
                elements of its know-how with principles inspired by the
                enhancement of people, the respect of ethical values, the
                promotion of local culture and the protection of the
                environment.
              </p>
              <p
                class="
                  corporate-social-responsibility_cards-blog-card-text-description
                "
              >
                Sustainability is a founding element deeply rooted in the
                Company’s identity and strategy, which represents a formal
                commitment towards the communities in which it operates.
              </p>
            </div>
          </div>
          <div class="corporate-social-responsibility_cards-blog-card-meta">
            <img
              class="corporate-social-responsibility_cards-blog-card-meta-photo"
               v-lazy="
              require(`@/assets/images/why-us/corporate-social-responsibility-${
                  index + 1
                }.png`)
            "
             
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["cards"],
};
</script>
<style lang="scss" scoped>
.corporate-social-responsibility {
  position: relative;
  background: -webkit-linear-gradient(top, #fff 50%, var(--bg-color-2) 50%);
  &:nth-child(1) {
    &::after {
      content: "";
      position: absolute;
      top: 36%;
      transform: translate(0, -50%);
      right: -80px;
      background-image: url("../../../../../assets/images/core-service/core-top.png");
      background-size: 400px 400px;
      display: inline-block;
      width: 400px;
      height: 400px;
    }
    &::before {
      content: "";
      position: absolute;
      bottom: 110px;
      left: -120px;
      background-image: url("../../../../../assets/images/core-service/core-bottom.png");
      background-size: 300px 300px;
      display: inline-block;
      width: 300px;
      height: 300px;
    }
  }

  @media (min-width: 900px) {
    padding: 70px 70px;
  }
  @media (min-width: 1024px) {
    padding: 70px 230px;
  }
  @media (min-width: 1900px) {
    padding: 100px 470px;
  }

  &_cards {
    padding: 40px;
    padding-left: 0;
    &-title {
      color: var(--text-normal-color);
      font-style: var(--normal-font-size);
      font-weight: 400;
      margin-bottom: 80px;
    }
    &-blog-card {
      display: flex;
      align-items: center;
      gap: 50px;
      flex-direction: column;
      @media (min-width: 900px) {
        flex-direction: row;
      }

      &-text {
        order: 2;
        flex: 0 0 50%;
        padding: 30px;
        padding-top: 130px;
        display: flex;
        flex-direction: column;
        gap: 30px;
        &-title {
          color: var(--primary-color);
          font-style: var(--big-font-size);
          font-weight: 700;
        }
        &-description {
          color: var(--text-normal-color);
          font-style: var(--normal-font-size);
          font-weight: 400;
        }
      }
      &-meta {
        flex: 0 0 50%;
        order: 1;
        &-photo {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
</style>